import React from 'react';
import styles from './styles/funds-in-account.module.scss';

const FundsInAccount = ({ total, advanced, overdue, available, minRecommended = 1350000, maxRecommended = 1650000 }) => {
    if (total === null || total === undefined) {
        return (
            <div className={styles.container}>
                <div className={styles.header}>
                    <h3 className={styles.title}>Funds In Account</h3>
                </div>
                <div className={styles.amount}>N/A</div>
            </div>
        );
    }
    
    const advancedPercent = (advanced || 0) / total * 100;
    const overduePercent = (overdue || 0) / total * 100;
    const availablePercent = (available || 0) / total * 100;
    
    const isWithinRange = total >= minRecommended && total <= maxRecommended;

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h3 className={styles.title}>Funds In Account</h3>
                {isWithinRange ? (
                    <span className={styles.badgeGreen}>Within recommended range</span>
                ) : (
                    <span className={styles.badgeRed}>Not within recommended range</span>
                )}
            </div>

            <div className={styles.amount}>${total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>

            <div className={styles.progressBar}>
                <div 
                    className={styles.advancedBar} 
                    style={{ width: `${advancedPercent}%` }}
                />
                <div 
                    className={styles.overdueBar} 
                    style={{ width: `${overduePercent}%` }}
                />
                <div 
                    className={styles.availableBar} 
                    style={{ width: `${availablePercent}%` }}
                />
            </div>

            <div className={styles.legend}>
                <div className={styles.legendItem}>
                    <div className={styles.dotAdvanced} />
                    <span>Advanced funds</span>
                </div>
                <div className={styles.legendItem}>
                    <div className={styles.dotOverdue} />
                    <span>Overdue funds</span>
                </div>
                <div className={styles.legendItem}>
                    <div className={styles.dotAvailable} />
                    <span>Available funds</span>
                </div>
            </div>
        </div>
    );
};

export default FundsInAccount;

